import { createApp, useTemplateRef } from './vue.esm-browser.js';
import './dayjs.min.js';
import { useShipDate } from './doyo.useShipDate.js';
import ShipTipDialog from './doyo.ship.dialog.comp.js';
import { useLogger } from './doyo.useLogger.js';
import { useState } from './doyo.useReactHooks.js';

(() => {
  const { Log } = useLogger('OR', { color: '#3fe' });
  Log('初始化加载完成');

  if (dayjs) {
    // do nth
  } else {
    Log('no dayjs');
  }

  const app = createApp({
    name: 'OrderReminderApp',
    template: '#tpl-order-reminder-app',
    components: {
      ShipTipDialog,
    },
    setup() {
      const shipDialogRef = useTemplateRef('shipDialogRef');

      const openDialog = evt => {
        Log('open btn clicked', evt);
        evt.preventDefault();

        if (shipDialogRef.value) {
          shipDialogRef.value?.open();
        }
      };

      const [icnRightUrl] = useState(icn_right_url ?? '');

      const { placedDate, shipTime, deliveredTime } = useShipDate();

      // Log('init app');

      return {
        placedDate,
        shipTime,
        deliveredTime,
        openDialog,
        icnRightUrl,
      };
    },
  });

  app.config.compilerOptions.delimiters = ['${', '}$'];
  app.mount('#order-reminder-app');
})();
